module.exports = __webpack_public_path__ + "static/media/men-faq.23237545.svg";